import { render, staticRenderFns } from "./Worklogs.vue?vue&type=template&id=5e4e3166&"
import script from "./Worklogs.vue?vue&type=script&lang=ts&"
export * from "./Worklogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports